import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9644_201212)">
      <path
        d="M6.75 18H0.75C0.551088 18 0.360322 17.921 0.21967 17.7803C0.0790176 17.6397 0 17.4489 0 17.25C0 17.0511 0.0790176 16.8603 0.21967 16.7197C0.360322 16.579 0.551088 16.5 0.75 16.5H6.75C6.94891 16.5 7.13968 16.579 7.28033 16.7197C7.42098 16.8603 7.5 17.0511 7.5 17.25C7.5 17.4489 7.42098 17.6397 7.28033 17.7803C7.13968 17.921 6.94891 18 6.75 18Z"
        fill="black"
      />
      <path
        d="M5.25 15H0.75C0.551088 15 0.360322 14.921 0.21967 14.7803C0.0790176 14.6397 0 14.4489 0 14.25C0 14.0511 0.0790176 13.8603 0.21967 13.7197C0.360322 13.579 0.551088 13.5 0.75 13.5H5.25C5.44891 13.5 5.63968 13.579 5.78033 13.7197C5.92098 13.8603 6 14.0511 6 14.25C6 14.4489 5.92098 14.6397 5.78033 14.7803C5.63968 14.921 5.44891 15 5.25 15Z"
        fill="black"
      />
      <path
        d="M3.75 12H0.75C0.551088 12 0.360322 11.921 0.21967 11.7803C0.0790176 11.6397 0 11.4489 0 11.25C0 11.0511 0.0790176 10.8603 0.21967 10.7197C0.360322 10.579 0.551088 10.5 0.75 10.5H3.75C3.94891 10.5 4.13968 10.579 4.28033 10.7197C4.42098 10.8603 4.5 11.0511 4.5 11.25C4.5 11.4489 4.42098 11.6397 4.28033 11.7803C4.13968 11.921 3.94891 12 3.75 12Z"
        fill="black"
      />
      <path
        d="M9.74755 17.9654C9.54863 17.9743 9.35435 17.9037 9.20744 17.7693C9.06053 17.635 8.97302 17.4477 8.96417 17.2488C8.95532 17.0499 9.02585 16.8556 9.16024 16.7087C9.29463 16.5618 9.48188 16.4743 9.6808 16.4654C11.1001 16.3356 12.4531 15.8039 13.5812 14.9329C14.7093 14.0618 15.5658 12.8873 16.0505 11.5469C16.5351 10.2066 16.6278 8.7559 16.3177 7.36478C16.0076 5.97365 15.3075 4.69969 14.2995 3.6921C13.2914 2.68451 12.0172 1.98502 10.6259 1.67555C9.23461 1.36608 7.78397 1.45945 6.44385 1.94472C5.10373 2.42998 3.92963 3.28706 3.05906 4.41556C2.1885 5.54407 1.65751 6.89727 1.5283 8.31667C1.51039 8.51479 1.41452 8.69768 1.26177 8.82511C1.10903 8.95254 0.911912 9.01407 0.713796 8.99617C0.515679 8.97827 0.332788 8.8824 0.205357 8.72965C0.0779261 8.5769 0.0163935 8.37979 0.0342956 8.18167C0.243462 5.87415 1.3345 3.73619 3.08029 2.21284C4.82609 0.689493 7.09213 -0.101881 9.40671 0.00345454C11.7213 0.10879 13.9061 1.10272 15.5063 2.77835C17.1065 4.45397 17.9988 6.68219 17.9975 8.99917C18.009 11.2479 17.1736 13.4186 15.6575 15.0794C14.1413 16.7402 12.0555 17.7695 9.81505 17.9624C9.79255 17.9647 9.7693 17.9654 9.74755 17.9654Z"
        fill="black"
      />
      <path
        d="M9 4.5C8.80109 4.5 8.61032 4.57902 8.46967 4.71967C8.32902 4.86032 8.25 5.05109 8.25 5.25V9C8.25004 9.1989 8.32909 9.38963 8.46975 9.53025L10.7198 11.7802C10.8612 11.9169 11.0507 11.9925 11.2473 11.9908C11.4439 11.989 11.6321 11.9102 11.7711 11.7711C11.9102 11.6321 11.989 11.4439 11.9908 11.2473C11.9925 11.0507 11.9169 10.8612 11.7802 10.7198L9.75 8.6895V5.25C9.75 5.05109 9.67098 4.86032 9.53033 4.71967C9.38968 4.57902 9.19891 4.5 9 4.5Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_9644_201212">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ClockIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default ClockIcon;
